<nav-aside></nav-aside>
<div class="m-grid__item m-grid__item--fluid m-wrapper">
  <div class="m-subheader">
    <div class="d-flex align-items-center">
      <div class="mr-auto">
        <h3 class="m-subheader__title">Demo Page</h3>
      </div>
    </div>
  </div>
  <div class="m-content">
    <router-outlet></router-outlet>
  </div>
</div>



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/app/@layout/body/body.component.html